import { combineReducers } from "redux";
import athleteReducer from "./atheleteReducer";
import authReducer from "./authReducer";
import fansReducers from "./fansReducers";
import TeamRosterReducer from "../reducers/TeamRosterReducer";
import sportReducer from "./sportReducer";
import requestedCitiesReducers from "./requestedCitiesReducers";
import requestedSportsReducers from "./requestedSportsReducers";
import userReducer from "./userReducer";
import subscriptionReducer from "./subscriptionReducer";
import seasonalReducer from "./seasonalReducer";
import resolutionCenterReducer from "./resolutionCenterReducer";
import walletReducer from "./walletReducer";
import myEndorseReducer from "./myEndorseReducer";
import talkingReducer from "./talkingReducer";
import contestReducer from "./contestReducer";
import hallFameReducer from "./hallFameReducer";
import markerReducer from "./markerReducer";
import tutorialsReducer from "./tutorialsReducer";
import getAdsReducers from "./getAdsReducers";
import athleteblogReducer from "./athleteBlogReducer";
import pizzaMoneyReducer from "./pizzaMoneyReducer";
import managerReducer from "./managerReducer";
import jobsReducer from "./jobsReducers";
import ratingReducers from "./ratingReducers";
import notificationsReducer from "./notificationsReducer";
import SportsCommunityBadgeReducer from "./SportsCommunityBadgeReducer";
import veriffReducer from "./veriffReducer";
import boostReducer from "./boostReducer";

export const appReducer = combineReducers({
  auth: authReducer,
  athlete: athleteReducer,
  fan: fansReducers,
  roaster: TeamRosterReducer,
  sport: sportReducer,
  requestedSports: requestedSportsReducers,
  requestedCities: requestedCitiesReducers,
  users: userReducer,
  subscription: subscriptionReducer,
  session: seasonalReducer,
  resolution: resolutionCenterReducer,
  wallet: walletReducer,
  endorseBadge: myEndorseReducer,
  talkingBadges: talkingReducer,
  contest: contestReducer,
  hallFame: hallFameReducer,
  marker: markerReducer,
  tutorials: tutorialsReducer,
  ads: getAdsReducers,
  athleteBlogs: athleteblogReducer,
  pizzaMoneyAthletes: pizzaMoneyReducer,
  manager: managerReducer,
  badges: jobsReducer,
  badgesRating: ratingReducers,
  notifications: notificationsReducer,
  sportsCommunityBadge: SportsCommunityBadgeReducer,
  veriff: veriffReducer,
  boost: boostReducer,
});
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_SUCCESS") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
export default rootReducer;
